import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "toggleButton"]
  
  connect() {
    this.isExpanded = false
  }

  toggleItems() {
    this.isExpanded = !this.isExpanded
    
    if (this.isExpanded) {
      this.itemTargets.forEach(item => item.classList.remove("hidden"))
      this.toggleButtonTarget.textContent = "Ver menos"
    } else {
      this.itemTargets.forEach((item, index) => {
        if (index >= 3) {
          item.classList.add("hidden")
        }
      })
      this.toggleButtonTarget.textContent = "Ver más"
    }
  }
} 